import React, { useEffect, useRef, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { AutoScrollableChartContainer } from "../components/AutoScrollableChartContainer/AutoScrollableChartContainer";
import { Bar } from "react-chartjs-2";
// import { ChartDemo2 } from "./pages/ChartDemo2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);
    
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Chart.js Bar Chart",
        },
      },
    };
    
    const Chart1 = (chartData) => {
      const [data, setData] = useState(chartData?.chartData?.data);
      const chartRef = useRef(null);
  return (
    <div className="chart-container">
       <AutoScrollableChartContainer data={chartData?.chartData?.data} chartRef={chartRef}>
        <Bar options={options} data={chartData?.chartData?.data} ref={chartRef} />
        </AutoScrollableChartContainer>
      {/* <ChartDemo2 /> */}
    </div>
  );
}
export default Chart1;
